import {Pipe, PipeTransform} from '@angular/core';
@Pipe({
    name: 'TxnStatusFilter'
})
export class TxnStatusFilter implements PipeTransform {
    transform(items: any, filter: any): any {
        if (items==null || items ==undefined) {
            return null;
        }
        return items.filter(item=>{
            return item.status === filter;
        })
    }
}


// WEBPACK FOOTER //
// ./src/filters/txnstatus.pipe.ts